module.exports = __webpack_public_path__ + "img/commodities.1095cc0d.svg";